<template>
    <default-modal
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
        @close="closeModal"
    >
        <ns-loader
            v-if="feed !== null"
            ref="nsLoader"
            :to-load="toLoad"
            :fetch-timer="null"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <el-form
                slot="content"
                ref="form"
                :model="form"
                :rules="rules"
                class="modal-confirm-feed"
            >
                <div class="flex-basis-6">
                    <el-form-item class="gcmcn-form-input">
                        <div class="gcmcn-form-label">Booking type</div>
                        <el-switch
                            v-model="isAutomaticBooking"
                            :disabled="datacenterUid === null"
                            active-text="Automatic"
                            inactive-text="Manual"
                            @change="$refs.form.clearValidate();"
                        >
                        </el-switch>
                    </el-form-item>
                </div>
                <template v-if="isAutomaticBooking">
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="booking_ip_main">

                                <div class="gcmcn-form-label type-input-spacing">Main source</div>
                                <el-select
                                    v-model="form.booking_ip_main"
                                    placeholder="Globecast region MAIN"
                                    class="gcmcn-form-label"
                                    popper-class="gcmcn-popper"
                                    filterable
                                >
                                    <template
                                        v-if="selectedMainIp && mainSourceIsBlurred"
                                        slot="prefix"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{selectedMainIp.name}}</span>
                                            <span class="ip-details">{{selectedMainIp.protocol.toLowerCase()}}://{{selectedMainIp.multicast_ip}}:{{selectedMainIp.port}}@{{selectedMainIp.source_ip}}</span>
                                        </div>
                                    </template>
                                    <el-option
                                        v-for="ip in mainIpsOptions"
                                        :key="ip.uid"
                                        :label="ip.name"
                                        :value="ip.uid"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{ip.name}}</span>
                                            <span class="ip-details">{{ip.protocol.toLowerCase()}}://{{ip.multicast_ip}}:{{ip.port}}@{{ip.source_ip}}</span>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="booking_ip_backup">

                                <div class="gcmcn-form-label type-input-spacing">Backup source</div>
                                <el-select
                                    v-model="form.booking_ip_backup"
                                    placeholder="Globecast region BACKUP"
                                    class="gcmcn-form-label"
                                    popper-class="gcmcn-popper"
                                    filterable
                                >
                                    <template
                                        v-if="selectedBackupIp && backupSourceIsBlurred"
                                        slot="prefix"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{selectedBackupIp.name}}</span>
                                            <span class="ip-details">{{selectedBackupIp.protocol.toLowerCase()}}://{{selectedBackupIp.multicast_ip}}:{{selectedBackupIp.port}}@{{selectedBackupIp.source_ip}}</span>
                                        </div>
                                    </template>
                                    <el-option
                                        v-for="ip in backupIpsOptions"
                                        :key="ip.uid"
                                        :label="ip.name"
                                        :value="ip.uid"
                                    >
                                        <div style="display: flex;justify-content: space-between;">
                                            <span class="ip-name">{{ip.name}}</span>
                                            <span class="ip-details">{{ip.protocol.toLowerCase()}}://{{ip.multicast_ip}}:{{ip.port}}@{{ip.source_ip}}</span>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_ip_main">
                                <div class="gcmcn-form-label">Main multicast ip</div>
                                <el-input
                                    v-model="form.multicast_network_ip_main"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_ip_backup">
                                <div class="gcmcn-form-label">Backup multicast ip</div>
                                <el-input
                                    v-model="form.multicast_network_ip_backup"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_src_main">
                                <div class="gcmcn-form-label">Main source ip</div>
                                <el-input
                                    v-model="form.multicast_network_src_main"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="multicast_network_src_backup">
                                <div class="gcmcn-form-label">Backup source ip</div>
                                <el-input
                                    v-model="form.multicast_network_src_backup"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="port_main">
                                <div class="gcmcn-form-label">Main port</div>
                                <el-input
                                    v-model.number="form.port_main"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-basis-5">
                            <el-form-item class="gcmcn-form-input" prop="port_backup">
                                <div class="gcmcn-form-label">Backup port</div>
                                <el-input
                                    v-model.number="form.port_backup"
                                    size="mini"
                                >
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="type">
                                <div class="gcmcn-form-label options-type">Type</div>
                                <el-select
                                    v-model="form.type"
                                    placeholder="UDP"
                                    popper-class="gcmcn-popper"
                                    class="gcmcn-form-label"
                                >
                                    <div class="gcmcn-form-label options-type"></div>
                                    <el-option
                                        v-for="item in options"
                                        :key="item.type"
                                        :label="item.label"
                                        :value="item.type"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <div
                    v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)"
                    class="gcmcn-inputs-container"
                >
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="datacenter_obj_uid">
                            <div
                                class="gcmcn-form-label type-input-spacing"
                            >
                                Globecast region
                            </div>
                            <el-select
                                v-model="form.datacenter_obj_uid"
                                :disabled="feed.confirmed"
                                class="gcmcn-form-label"
                                @change="resetBookingIp"
                            >
                                <el-option
                                    v-for="datacenter in datacenters"
                                    :key="datacenter.uid"
                                    :label="datacenter.name"
                                    :value="datacenter.uid"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-alert
                    type="warning"
                    effect="dark"
                    :closable="false"
                >
                    <p style="font-weight: bolder; word-break: break-word">Do you really want to update this feed input ?<br>
                    Please check carefully the data provided and confirm the action by typing "CONFIRM"</p>
                    <el-form-item class="gcmcn-form-input" style="margin-top: 15px;" prop="passPhrase">
                        <el-input v-model="form.passPhrase" placeholder="Enter confirm"></el-input>
                    </el-form-item>
                </el-alert>
            </el-form>
        </ns-loader>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="confirmModificationRequest"
            >Validate</el-button>
        </div>
    </default-modal>

</template>

<script>
import moment from 'moment';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        DefaultModal,
        NsLoader,
        LoadingTemplate,
    },

    props: {

    },

    data (){
        return {
            showModal: false,
            isAutomaticBooking: false,
            mainIps: [],
            backupIps: [],
            datacenters:[],
            form: {
                multicast_network_ip_main: '',
                multicast_network_src_main: '',
                multicast_network_ip_backup: '',
                multicast_network_src_backup: '',
                datacenter_obj_uid: '',
                port_main: 0,
                port_backup: 0,
                passPhrase: '',
                type: 'RTP',
                booking_ip_main: null,
                booking_ip_backup: null,
            },
            options: [{
                type: 'UDP',
                label: 'UDP'
            },
            {
                type: 'RTP',
                label: 'RTP'
            }],
            loading: false,
            feed: null,
            event: null,
            videoSource: null,
            mainSourceIsBlurred: true,
            backupSourceIsBlurred: true,
        };
    },

    computed: {
        ...mapGetters([
            'entitiesByUid',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
        ]),
        entityUid(){
            if(this.feed){
                return this.feed.scopes.entity_uid;
            }
            return null;
        },
        selectedMainIp(){
            if(this.form.booking_ip_main){
                return this.mainIps.find(ip => ip.uid === this.form.booking_ip_main);
            }
            return null;
        },
        selectedBackupIp(){
            if(this.form.booking_ip_backup){
                return this.backupIps.find(ip => ip.uid === this.form.booking_ip_backup);
            }
            return null;
        },
        toLoad (){
            let modelTofetch = [];
            if(this.feed && this.datacenterUid){
                modelTofetch.push({
                    model: 'ips',
                    name: 'ips',
                    filters:{
                        datacenter_uid: this.datacenterUid,
                        archived: false,
                        ordering: 'name'
                    }
                });
            }
            if(this.feed && this.feed.confirmed){
                modelTofetch.push({
                    model: 'videoSources',
                    name: 'videoSource',
                    uid: this.feed.video_source_uid,
                });
            }
            return [
                {
                    model: 'datacenters',
                    name: 'datacenters',
                    filters:{
                        archived: false,
                    }
                },
                ...modelTofetch
            ];
        },
        rules (){
            let rules = {
                passPhrase: [{ validator: this.checkConfirm, required: true}],
            };
            if(this.isAutomaticBooking){
                rules = Object.assign(rules, {
                    booking_ip_main: [{required: true, message: 'Globecast region MAIN is required.'}],
                    booking_ip_backup: [{ required: true, message: 'Globecast region BACKUP is required.'}],
                });
            }else{
                rules = Object.assign(rules, {
                    type: [{ type: 'string', required: true}],
                    multicast_network_ip_main: [{validator: this.checkIp, required: true}],
                    multicast_network_src_main: [{validator: this.checkIp, required: true}],
                    multicast_network_ip_backup: [{validator: this.checkIp, required: true}],
                    multicast_network_src_backup: [{validator: this.checkIp, required: true}],
                    port_main: [{type: 'number', required: true}],
                    port_backup: [{type: 'number', required: true}],
                });
            }

            return rules;
        },
        datacenterUid(){
            if(this.entitiesByUid(this.feed.scopes.entity_uid).datacenter_uid){
                return this.entitiesByUid(this.feed.scopes.entity_uid).datacenter_uid;
            }
            return null;
        },
        mainIpsOptions(){
            return this.mainIps.filter(ip => ip.datacenter === this.form.datacenter_obj_uid);
        },
        backupIpsOptions(){
            return this.backupIps.filter(ip => ip.datacenter === this.form.datacenter_obj_uid);
        },
    },

    mounted (){
    },

    methods: {
        resetBookingIp(){
            this.$set(this.form, 'booking_ip_main', '');
            this.$set(this.form, 'booking_ip_backup', '');
        },
        checkIp (rule, value, callback) {
            if(!value){
                return callback(new Error('This field can\'t be empty'));
            }else if(!value.match(this.$store.getters.regexIp)){
                return callback(new Error('This field must be a valid ip'));
            }
            callback();
        },

        checkConfirm (rule, value, callback) {
            if(!value){
                return callback(new Error('Pass phrase is required'));
            }else if(value !== 'CONFIRM'){
                return callback(new Error('Pass phrase must be equal to CONFIRM in uppercase.'));
            }
            callback();
        },
        onDataFetched (res){
            this.$set(this, 'datacenters', res.datacenters);
            if(res.ips){
                let mainIps = res.ips.filter(ip => ip.ip_type === 'main');
                let backupIps = res.ips.filter(ip => ip.ip_type === 'backup');
                this.$set(this,'mainIps',mainIps);
                this.$set(this,'backupIps',backupIps);
                if(!this.feed.confirmed){
                    this.isAutomaticBooking = true;
                }
            }
            if(res.videoSource){
                this.$set(this, 'videoSource', res.videoSource);
                if(this.feed.booking_type === 'manual'){
                    this.form.datacenter_obj_uid = this.videoSource.datacenter_obj_uid;
                    this.form.multicast_network_ip_main = this.videoSource.multicast_network_ip_main;
                    this.form.multicast_network_src_main = this.videoSource.multicast_network_src_main;
                    this.form.multicast_network_ip_backup = this.videoSource.multicast_network_ip_backup;
                    this.form.multicast_network_src_backup = this.videoSource.multicast_network_src_backup;
                    this.form.datacenter_obj_uid = this.videoSource.datacenter_obj_uid;
                    this.form.port_main = parseInt(this.videoSource.port_main);
                    this.form.port_backup = parseInt(this.videoSource.port_backup);
                    this.form.type = this.videoSource.type;
                }  else {
                    this.form.datacenter_obj_uid = this.videoSource.datacenter_obj_uid;
                }
            }
        },
        open (feed, event){
            this.$set(this, 'feed', feed);
            this.$set(this, 'event', event);
            if(this.feed.booking_type === 'automatic'){
                this.$set(this.form, 'booking_ip_main', this.feed.booking_ip_main_uid);
                this.$set(this.form, 'booking_ip_backup', this.feed.booking_ip_backup_uid);
                this.isAutomaticBooking= true;
            }
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
            this.resetFields();
            this.$set(this, 'feed', null);
            this.$set(this, 'event', null);
            this.form.passPhrase = '';

        },
        resetFields(){
            this.form = {
                multicast_network_ip_main: '',
                multicast_network_src_main: '',
                multicast_network_ip_backup: '',
                multicast_network_src_backup: '',
                port_main: 0,
                port_backup: 0,
                confirmed_start_date: '',
                confirmed_start_time: '',
                confirmed_end_date: '',
                confirmed_end_time: '',
                booking_ip_main: null,
                booking_ip_backup: null,
                passPhrase: '',
                type: 'RTP',
            };
        },
        deleteManualBookingField(context){
            delete context.multicast_network_ip_main;
            delete context.multicast_network_src_main;
            delete context.multicast_network_ip_backup;
            delete context.multicast_network_src_backup;
            delete context.port_main;
            delete context.port_backup;
            delete context.type;

            context['booking_type'] = 'automatic';

            return context;
        },
        deleteAutoBookingFields(context){
            delete context.booking_ip_main_uid;
            delete context.booking_ip_backup_uid;

            context['booking_type'] = 'manual';

            return context;
        },
        confirmModificationRequest (){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;
                this.loading = true;
                let context = Object.assign({}, this.form);
                if(this.isAutomaticBooking){
                    context = this.deleteManualBookingField(context);
                }else{
                    context = this.deleteAutoBookingFields(context);
                }
                let contextJSON = JSON.parse(JSON.stringify(context));
                delete contextJSON ['passPhrase'];
                delete contextJSON ['datacenter_obj_uid'];
                this.$store.dispatch('createItem', {
                    item: {
                        context: contextJSON,
                        status: 'PENDING',
                        action: 'UPDATE',
                        feed_uid: this.feed.uid,
                    },
                    model: 'feedModificationRequests',
                    url: this.$store.state.api.meta.listModels.feedModificationRequests.url

                }).then((res) => {
                    this.$emit('watch-feed-modification-request', res.url);
                    this.closeModal();
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
    },
};
</script>

<style lang="scss">
.modal-confirm-feed{
    .gcmcn-form-label.el-select{
        .el-input{
            &__prefix{
                width: 550px;
                padding: 13px 25px;
                background-color: #444;
                color: #fff;
            }
        }
    }
    .el-input:not(.hours):not(.minutes):not(.seconds):not(.digital-clock){
        width: 100%;
    }
    .el-alert{
        .el-form-item__error{
            color: #ff1100;
        }
    }
    .options-type {
        padding-bottom: 0.5em;;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/page/Feeds/feed-modification.vue